import { render, staticRenderFns } from "./RubricPresetForm.vue?vue&type=template&id=219138d3&scoped=true"
import script from "./RubricPresetForm.vue?vue&type=script&lang=js"
export * from "./RubricPresetForm.vue?vue&type=script&lang=js"
import style0 from "@/utils/rich_text_editor.css?vue&type=style&index=0&id=219138d3&prod&scoped=true&lang=css&external"
import style1 from "./RubricPresetForm.vue?vue&type=style&index=1&id=219138d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219138d3",
  null
  
)

export default component.exports